import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome, FontAwesome5, FontAwesome6, Fontisto, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import Feather from "@expo/vector-icons/Feather";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import * as Linking from 'expo-linking';




const Contact =({navigation})=>{

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        ارتباط با ما
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <ScrollView style={{flex:1  , backgroundColor : Config.maincolor}}>
                <View style={styles.content}>

                    <TouchableOpacity style={styles.row} onPress={()=>Linking.openURL('https://www.instagram.com/himora_language_center')}>
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                                صفحه اینستاگرام ما
                            </Text>
                            <Text style={styles.desitem}>
                                 @himora_language_center
                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <AntDesign style={styles.iconcontainer} name="instagram" size={RFValue(45)} color={'red'} />
                        </View>

                    </TouchableOpacity>
                    <TouchableOpacity style={styles.row} onPress={()=>Linking.openURL('https://t.me/himora_language_center')}>
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                                کانال تلگرام ما
                            </Text>
                            <Text style={styles.desitem}>
                                 @himora_language_center
                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <FontAwesome5 name="telegram-plane" size={RFValue(45)} color={'#229ED9'} />
                        </View>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.row} onPress={()=>Linking.openURL('https://wa.me/989335764551?text=%D8%B3%D9%84%D8%A7%D9%85')}>
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                               تماس از طریق واتساپ
                            </Text>
                            <Text style={styles.desitem}>
                                09335764551
                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <Fontisto name="whatsapp" size={RFValue(45)} color="#128C7E" />
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.row} onPress={()=>Linking.openURL('tel:04433379562')}>
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                                تماس تلفنی با پشتیبان
                            </Text>
                            <Text style={styles.desitem}>
                                04433379562
                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <Feather name="phone-call" size={RFValue(45)} color="#4DA6FF" />
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.row} onPress={()=>navigation.navigate('Tickets')}>
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                                ارسال تیکت به پشتیبان
                            </Text>
                            <Text style={styles.desitem}>

                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <Entypo name="chat" size={RFValue(45)} color={Config.secondcolor}  />
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.row} onPress={()=>Linking.openURL('https://himoralanguagecenter.com')} >
                        <View style={styles.item}>
                            <Text style={styles.titleitem}>
                                وب سایت هیمورا
                            </Text>
                            <Text style={styles.desitem}>
                                himoralanguagecenter.com
                            </Text>
                        </View>
                        <View style={styles.iconbox}>
                            <MaterialCommunityIcons   name="web"size={RFValue(45)} color={'blue'}   />
                        </View>
                    </TouchableOpacity>


                </View>
            </ScrollView>


        </View>
    );
}

const styles = StyleSheet.create({

    row :{
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingVertical : RFValue(10),
      paddingHorizontal: RFValue(10),
        marginVertical: RFValue(20),
        borderRadius: RFValue(10),
        borderWidth: RFValue(1),
        borderColor: 'gray',
        backgroundColor: 'white',
    },
    titleitem : {
        fontSize: RFValue(13),
        fontFamily : 'yk',
        color: 'black',
        paddingVertical: RFValue(0),
    },
    desitem : {
        fontSize: RFValue(12),
        fontFamily : 'yk',
        color: '#181818',
        paddingVertical: RFValue(0),

    },
    iconbox : {
      borderRadius: RFValue(80),
      width: RFValue(80),
      height: RFValue(80),
        borderWidth: RFValue(1),
        borderColor: 'gray',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: -RFValue(10),
        backgroundColor: 'white',
    },

    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),

        paddingVertical: RFValue(20),
        backgroundColor :Config.maincolor,
    },

    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

})


export default Contact